import React from "react";
import enhanceWithValidation, {
  dateRangeValidDateValidation,
  dateRangeBoundaryValidation,
  dateRangeMinValueValidation,
  dateRangeMaxValueValidation,
} from "@civicplus/preamble-ui/lib/Validations";
import DateRangeWrapper from "./DateRangeWrapper";
import { updateEventFilters, updateSelectedDate } from "../../../actions";
import { makeStyles } from "@civicplus/preamble-ui/lib/Utilities/ThemeHelper";
import { AppDispatch, RootState } from "../../../app/store";
import { useDispatch, useSelector } from "react-redux";
import { lighten } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  dateFilter: {
    flexWrap: "nowrap",
    [theme.breakpoints.up("lg")]: {
      flexDirection: "column",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
    "& .prmbl-range-component": {
      [theme.breakpoints.up("lg")]: {
        marginBottom: theme.spacing(2),
        padding: 0,
        flexBasis: "100%",
        maxWidth: "100%",
      },
      [theme.breakpoints.down("xs")]: {
        marginBottom: theme.spacing(1),
        padding: 0,
        flexBasis: "100%",
        maxWidth: "100%",
      },

      "&:first-child": {
        [theme.breakpoints.down("md")]: {
          paddingRight: theme.spacing(1),
        },
        [theme.breakpoints.down("xs")]: {
          paddingRight: 0,
        },
      },
      "& fieldset": {
        borderColor: lighten(theme.palette.grey["600"], 0.2),
      },
    },
  },
}));

const EnhancedDateRange = enhanceWithValidation(DateRangeWrapper);

const DateFilter: React.FC = () => {
  const eventFilters = useSelector((state: RootState) => state.eventFilters);
  const dispatch = useDispatch<AppDispatch>();
  const classes = useStyles();

  const onDateFilterChange = (
    _: unknown,
    date: { from: Date | null; to: Date | null }
  ) => {
    // Only goes if the new values are different
    if (JSON.stringify(dateForInputs) !== JSON.stringify(date)) {
      // In case that it is a clean fields
      if (!date?.from && !date?.to) {
        dispatch(updateSelectedDate(""));
        dispatch(
          updateEventFilters({
            date: { from: null, to: null },
          })
        );
      } else {
        // If there is a input-from date in the range, we use that on the mini-calendar, if not, we use the input-to date.
        const selectedDate = date.from ? date.from : date.to;

        const parsedData = {
          from: date.from ? date.from.toDateString() : null,
          to: date.to ? date.to.toDateString() : null,
        };
        dispatch(
          updateEventFilters({
            date: parsedData,
          })
        );
        if (selectedDate !== null)
          dispatch(updateSelectedDate(selectedDate.toDateString()));
      }
    }
  };
  const dateForInputs = {
    from: eventFilters?.date?.from ? new Date(eventFilters.date.from) : null,
    to: eventFilters?.date?.to ? new Date(eventFilters.date.to) : null,
  };
  return (
    <aside aria-label="Filter to events from a specific date range">
      <EnhancedDateRange
        className={classes.dateFilter}
        autofocus={false}
        fromProps={{ label: "From Date" }}
        id="Filter-Date"
        onChange={onDateFilterChange}
        toProps={{ label: "To Date" }}
        value={dateForInputs}
        format="MM/dd/yyyy"
        fullWidth={true}
        validations={[
          dateRangeMinValueValidation,
          dateRangeMaxValueValidation,
          dateRangeValidDateValidation,
          dateRangeBoundaryValidation,
        ]}
      />
    </aside>
  );
};

export default DateFilter;
